class FTDGoogleMaps extends HTMLElement {
  constructor () {
    super()

    dayjs.extend(window.dayjs_plugin_utc)
    dayjs.extend(window.dayjs_plugin_timezone)
    this.timeZone = window.ftdMemberPreferences.shopTimeZone
    dayjs.tz.setDefault(this.timeZone)

    this.mapSection = document.querySelector('.ftd-google-maps')
    this.mapElement = document.querySelector('.map-section__content')
    this.shopHoursContainer = this.mapElement.querySelector('.shop-hours')
    this.hideMapBackground = window.innerWidth < 767
    let readGBPData = window.ftdMemberPreferences.readGBPData
    this.readGBPData = String(readGBPData?.gbp).trim().toLowerCase() === 'true'
  }

  connectedCallback () {
    this.googleMapsUnsubscriber = subscribe(PUB_SUB_EVENTS.locationsUpdate, () => {
      this.onGoogleMapsLoad()
    })
  }

  disconnectedCallback () {
    if (this.googleMapsUnsubscriber) {
      this.googleMapsUnsubscriber()
    }
  }

  onGoogleMapsLoad () {
    this.showGoogleMap()
  }

  showGoogleMap () {
    this.mapSection.classList.remove('hidden')

    const stores = window.ftdMemberPreferences.stores
    const memberCodes = Object.keys(stores).filter(code => {
      const { latitude, longitude } = this.getLocation(stores[code])
      return latitude && longitude
    })
    const totalStores = memberCodes.length

    if (!totalStores) return

    const firstShop = stores[memberCodes[0]] || {}
    this.updateCard(firstShop)

     const markers = []

    /* Marker configration */
    const mapMarker = window.google ? {
      url: this.dataset.markerIcon,
      size: new google.maps.Size(100, 100),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(50, 75),
      scaledSize: new google.maps.Size(100, 100)
    } : null;

    const clickedMarkerIcon = window.google ? {
      url: this.dataset.markerIcon,
      anchor: new google.maps.Point(70, 105),
      scaledSize: new google.maps.Size(140, 140),
    } : null;

    let activeMarker = 0;

    const setActiveMarker = (index) => {
      const marker = markers[index]
      if(activeMarker && activeMarker !== marker) {
        activeMarker.setIcon(mapMarker)
      }
      marker.setIcon(clickedMarkerIcon)
      activeMarker = marker;
    }

    if (!this.hideMapBackground) {
      const { latitude, longitude } = this.getLocation(firstShop)
      const map = new google.maps.Map(this, {
        center: new google.maps.LatLng(latitude, longitude),
        maxZoom: 13,
        draggable: true,
        disableDefaultUI: true,
        zoomControl: false,
        clickableIcons: false,
        disableDoubleClickZoom: false,
        streetViewControl: false,
        mapTypeControl: false,
        gestureHandling: 'cooperative'
      })

      google.maps.event.addListener(map, 'mouseout', function () {
        this.setOptions({ scrollwheel: false })
      })
      map.addListener('click', function () {
        map.set('scrollwheel', true)
      })
      memberCodes.forEach((e, index) => {
        const { latitude, longitude } = this.getLocation(stores[e])
        const marker = new google.maps.Marker({
          map,
          position: new google.maps.LatLng(latitude, longitude),
          icon: mapMarker,
          clickable: true
        })
        markers.push(marker)

        var parent = this
        google.maps.event.addListener(marker, 'click', function () {
          setActiveMarker(index)
          parent.updateCard(stores[e], index)
          parent.updateButton(index, totalStores)
        })
      })

      setActiveMarker(0)

      const bounds = new google.maps.LatLngBounds()
      if (markers.length > 0) {
        for (let i = 0; i < markers.length; i++) {
          bounds.extend(markers[i].getPosition())
        }

        const mapDiv = map.getDiv()
        const safeOffsetRatio = 0.15 // 15% offset

        map.fitBounds(bounds, {
          top: 50,
          bottom: 50,
          left: 100,
          right: 0
        })

        if (!(this.mapSection.classList.contains('mini-view'))) {
          function offsetCenter(map, latlng, offsetX, offsetY) {
            const scale = Math.pow(2, map.getZoom())
            const projection = map.getProjection()
            if (!projection) return

            const worldCoordinateCenter = projection.fromLatLngToPoint(latlng)
            const pixelOffset = new google.maps.Point((offsetX/scale) || 0, (offsetY/scale) || 0)

            const worldCoordinateNewCenter = new google.maps.Point(
              worldCoordinateCenter.x - pixelOffset.x,
              worldCoordinateCenter.y + pixelOffset.y
            )

            const newCenter = projection.fromPointToLatLng(worldCoordinateNewCenter)
            map.setCenter(newCenter)
          }

          google.maps.event.addListenerOnce(map, 'idle', () => {
            let minLat = Infinity, maxLat = -Infinity, minLng = Infinity, maxLng = -Infinity;
            markers.forEach(marker => {
              const pos = marker.getPosition();
              minLat = Math.min(minLat, pos.lat());
              maxLat = Math.max(maxLat, pos.lat());
              minLng = Math.min(minLng, pos.lng());
              maxLng = Math.max(maxLng, pos.lng());
            });

            const latDiff = (maxLat - minLat);
            const lngDiff = (maxLng - minLng);

            let zoom = Math.floor(Math.log2(360 / Math.max(latDiff, lngDiff)));
            zoom = Math.min(zoom, 13); // max zoom limit
            map.setZoom(zoom);

            const center = map.getCenter()
            const offsetX = mapDiv.offsetWidth * safeOffsetRatio // 10% shift
            const offsetY = 0
            offsetCenter(map, center, offsetX, offsetY)
          })
        }
      }
    }
      
    const leftBtn = this.mapElement.querySelector('.left-btn')
    const rightBtn = this.mapElement.querySelector('.right-btn')
    const chevronContainers = this.mapElement.querySelectorAll('.chevron-container')

    if (totalStores <= 1) {
      chevronContainers.forEach(container => {
        container.style.display = 'none'
      })
    }

    rightBtn && rightBtn.addEventListener('click', (e) => {
      e.preventDefault()
      if (rightBtn.classList.contains('disabled')) return

      const newIndex = parseInt(this.mapElement.dataset.index) + 1
      const shop = stores[memberCodes[newIndex]]

      this.updateCard(shop, newIndex)
      this.updateButton(newIndex, totalStores)
      if(!this.hideMapBackground){
        setActiveMarker(newIndex)
      }
    })

    leftBtn && leftBtn.addEventListener('click', (e) => {
      e.preventDefault()
      if (leftBtn.classList.contains('disabled')) return

      const newIndex = parseInt(this.mapElement.dataset.index) - 1
      const shop = stores[memberCodes[newIndex]]

      this.updateCard(shop, newIndex)
      this.updateButton(newIndex, totalStores)
      if(!this.hideMapBackground){
        setActiveMarker(newIndex)
      }
    })
  }

  updateButton (index, totalStores) {
    const leftBtn = this.mapElement.querySelector('.left-btn')
    const rightBtn = this.mapElement.querySelector('.right-btn')

    if (index === 0) {
      leftBtn.classList.add('disabled')
    } else {
      leftBtn.classList.remove('disabled')
    }

    if (index === totalStores - 1) {
      rightBtn.classList.add('disabled')
    } else {
      rightBtn.classList.remove('disabled')
    }
  }

  getLocation (shop) {
    const { latitude = '', longitude = '', gbpDetails: { location = {} } = {} } = shop
    if (this.readGBPData && location.latitude && location.longitude) return location
    return { latitude, longitude }
  }

  updateCard (shop, index = 0) {    
    const { name = '', address = {}, phone = '', email = '', shopHours = {}, shopHoursOverrides = [], shopTollFree = '', gbpDetails : { shopName : gbpShopName = '', address : gbpAddress = '', phone : gbpPhone = '', businessName = '' } = {} } = shop
    const shopName = this.readGBPData ? (businessName || gbpShopName || name) : name
    const shopAddress = this.readGBPData && gbpAddress
      ? gbpAddress
      : `${address.address1 || ''} <br> ${address.city || ''}, ${address.province || ''} ${address.postalCode || ''}`
    const shopPhone = this.readGBPData && gbpPhone ? gbpPhone : phone
    this.mapElement.setAttribute('data-index', index)
    this.mapElement.querySelector('.shop-name').innerHTML = shopName
    this.mapElement.querySelector('.shop-address').innerHTML = shopAddress
    this.mapElement.querySelector('.shop-phone').innerHTML = this.renderPhoneLink(shopPhone)
    this.mapElement.querySelector('.shop-tollfree').innerHTML = this.renderPhoneLink(shopTollFree)
    this.mapElement.querySelector('.shop-hours').innerHTML = this.fetchShopHours(shopHours, shopHoursOverrides)

    const shopEmail = this.mapElement.querySelector('.shop-email')

    if (shopEmail) shopEmail.innerHTML = this.renderEmailLink(email)

    const getDirectionsBtn = this.mapElement.querySelector('.map_section__directions-btn')
    if (getDirectionsBtn) {
      getDirectionsBtn.href = `https://maps.google.com?daddr=${this.mapElement.querySelector('.shop-address').innerHTML}`
      getDirectionsBtn.classList.remove('hidden')
    }
  }

  renderPhoneLink(phone) {
    if (!phone) return ''
    const digits = String(phone).replace(/[^\d+]/g, '')
    if (!digits) return phone
    return `<a href="tel:${digits}">${phone}</a>`
  }

  renderEmailLink(email) {
    if (!email) return ''
    const trimmed = String(email).trim()
    if (!trimmed) return ''
    return `<a href="mailto:${trimmed}">${trimmed}</a>`
  }

  fetchShopHours(shopHours = {}, shopHoursOverrides = []) {
    const locale = Shopify.locale || 'en'
    const orderedDays = {
      en: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      fr: ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'],
      es: ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo']
    }
    const shopClosedText = {
      en: 'CLOSED',
      fr: 'FERMÉ',
      es: 'CERRADO'
    }
    const specialHoursHeading = {
      en: 'SPECIAL/HOLIDAY HOURS',
      fr: 'HORAIRES SPÉCIAUX/FÊTES',
      es: 'HORARIO ESPECIAL/VACACIONES'
    }
    const days = orderedDays[locale]

    const today = dayjs.tz().startOf('day')

    const upcomingOverrides = shopHoursOverrides.filter(override => {
      const overrideDate = dayjs(override.startDate).startOf('day')
      const diffDays = overrideDate.diff(today, 'day')
      return diffDays >= 0 && diffDays <= 30
    }).sort((a, b) => dayjs(a.startDate).diff(dayjs(b.startDate)))

    const formatTime = (time) => {
      return time
        .replace(/00:00PM/, '12:00PM')
        .replace(/ /, '')
        .replace(/^0/, '')
    }

    let HTMLShopHours = ''
    days.forEach((day, index) => {
      HTMLShopHours += `<div class="shop-hours-row">
        <span class="shop-hours-day">${day}</span>
        <span class="shop-hours-timing">`

      const dayOfWeekEn = orderedDays.en[index]
      const time = shopHours[dayOfWeekEn.toUpperCase()]
      if (time) {
        var [start, end] = time.split(/-/)
        if (start) {
          start = formatTime(start)
        }
        if (end) {
          end = formatTime(end)
          HTMLShopHours += `<span class="shop-hours-open"><time>${start} </time></span>
            <span class="shop-hours-delim">-</span>
            <span class="shop-hours-close"><time> ${end}</time></span>`
        } else {
          HTMLShopHours += `<span class="shop-hours-open">${shopClosedText[locale]}</span>`
        }
      }
      HTMLShopHours += '</span></div>'
    })

    if (upcomingOverrides.length > 0) {
      document.querySelector('.contact__form_parent')?.classList.add('contact__form_parent_shop_hours')
      HTMLShopHours += `
        <hr class="shop-hours-divider">
        <div class="special-hours-heading">${specialHoursHeading[locale]}</div>
      `
    }

    if (upcomingOverrides.length > 4) {
      this.shopHoursContainer.classList.add("shop-hours-overriden")
    }

    upcomingOverrides.forEach(override => {
      const date = dayjs(override.startDate)
      const formattedDay = date.locale(locale).format('dddd')
      const formattedDate = date.locale(locale).format(`${override.label ? "dddd, " : ""}MMM D`)
      const labelClass = override.label ? 'with-label' : 'without-label';

      let specialHoursHTML = `<div class="shop-hours-row shop-hours-row-overriden ${labelClass}">
        <span class="shop-hours-day">
          ${override.label || formattedDay}
          <div class="shop-hours-day shop-hours-date">
            ${formattedDate}
          </div>
        </span>
        <span class="shop-hours-timing">`

      if (override.status === 'Opened' && override.openTime && override.closeTime) {
        specialHoursHTML += `<span class="shop-hours-open"><time>${formatTime(override.openTime)}</time></span>
          <span class="shop-hours-delim">-</span>
          <span class="shop-hours-close"><time>${formatTime(override.closeTime)}</time></span>`
      } else {
        specialHoursHTML += `<span class="shop-hours-open">${shopClosedText[locale]}</span>`
      }

      specialHoursHTML += '</span></div>'
      HTMLShopHours += specialHoursHTML
    });

    return HTMLShopHours
  }
}

customElements.define('ftd-google-maps', FTDGoogleMaps)
